var map = {
	"./alumni-intro.png": 396,
	"./alumnievent.png": 917,
	"./igs_logo.png": 344,
	"./intro-image.png": 341,
	"./laboratoryevent.jpg": 102,
	"./library.jfif": 417,
	"./logo.svg": 576,
	"./mission.jpg": 569,
	"./principal1.jpg": 428,
	"./principal2.jpg": 475,
	"./principal3.jpg": 862,
	"./shapes.jpg": 725
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 540;